var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { cloneDeep, first, forEach, isEmpty, pick } from 'lodash';
import { DeviceUtilitiesService, EMPTY_TEXT, TagType } from '@mitchell/react.component.ux';
import { MimeTypeService, getMimeType, TranslationService, CountryCode, EnterpriseDocStoreService, formatDateTime, HttpStatusCode, HttpHeaderType, HttpContentType, HttpCacheType, HttpMethodType } from "../../common";
import { FileUploadError, FileValidationService } from "../../file";
import { VehicleInfoState } from "../../vehicleInfo";
import { downloadAartifactsGalleryProps, IntelligentPhotoCapturePhotoPreviewConstants, OCR_ENABLED_SUBTYPES, OCR_previewScreen_RegEx_validator, PhotoCaptureAllowedMimeTypeConstant, PhotoCaptureConstants, PhotoCaptureFileExtensionAllowedForGallery, PRG_QUESTIONS_SUB_TYPE, PROGRESSIVE_CO_CODES, RequestAdditionalErrorMessage, SERVICE_FAIL_STATUS } from '../constants';
import { IntelligentPhotoCaptureViewType, PhotoCaptureAttributeType, PhotoCaptureImageDescription, PhotoCaptureImageClass, PhotoCaptureAssignmentTypes, PhotoCaptureAssignmentSubTypes, PhotoCaptureDownloadArtifactsCategoryNames, PhotoCaptureDownloadArtifactsLabelNames } from '../enums';
/**
 * Utility Function photoCapture.
 * @function getFileDescriptionByAttributeType
 * @argument attibuteType
 * @argument isParentImage
 * based on attributeType will return description for screen to be send in service
 * @returns string
 */
export const getFileDescriptionByAttributeType = (attibuteType, isParentImage = true, sequenceScreenName = EMPTY_TEXT) => {
    switch (attibuteType) {
        case PhotoCaptureAttributeType.LICENSE_PLATE_CAPTURE:
            return PhotoCaptureImageDescription.LICENSE_PLATE;
        case PhotoCaptureAttributeType.MILEAGE_CAPTURE:
            return PhotoCaptureImageDescription.VEHICLE_MILEAGE;
        case PhotoCaptureAttributeType.VIN_CAPTURE:
            return PhotoCaptureImageDescription.VEHICLE_IDENTIFICATION;
        case PhotoCaptureAttributeType.VIN_STICKER:
            return PhotoCaptureImageDescription.VEHICLE_VIN_STICKER;
        case PhotoCaptureAttributeType.SINGLE_WIDE_SHOT:
            return PhotoCaptureImageDescription.WIDE_SHOT;
        case PhotoCaptureAttributeType.VIDEO_CAPTURE:
            return PhotoCaptureImageDescription.WALK_AROUND_VIDEO;
        case PhotoCaptureAttributeType.WIDE_ENHANCED:
            if (isParentImage) {
                return PhotoCaptureImageDescription.WIDE_ENHANCED;
            }
            return PhotoCaptureImageDescription.WIDE_ENHANCED_ADDITIONAL;
        case PhotoCaptureAttributeType.CLOSEUP_ENHANCED:
            if (isParentImage) {
                return PhotoCaptureImageDescription.CLOSEUP_ENHANCED;
            }
            return PhotoCaptureImageDescription.CLOSEUP_ENHANCED_ADDITIONAL;
        case PhotoCaptureAttributeType.FOUR_CORNERS_CAPTURE:
            return sequenceScreenName;
        case PhotoCaptureAttributeType.THREE_CLOSE_UP:
            return sequenceScreenName;
        case PhotoCaptureAttributeType.SUMMARY:
            return PhotoCaptureImageDescription.SUMMARY;
        default:
            return '';
    }
};
/**
 * Utility Function photoCapture.
 * @function getImageClassByAttributeType
 * @argument attibuteType
 * based on attributeType will return image class for screen to be render on screen
 * @returns string
 */
export const getImageClassByAttributeType = (attibuteType) => {
    switch (attibuteType) {
        case PhotoCaptureAttributeType.LICENSE_PLATE_CAPTURE:
            return PhotoCaptureImageClass.LICENSE_PLATE;
        case PhotoCaptureAttributeType.MILEAGE_CAPTURE:
            return PhotoCaptureImageClass.VEHICLE_MILEAGE;
        case PhotoCaptureAttributeType.VIN_CAPTURE:
            return PhotoCaptureImageClass.VEHICLE_IDENTIFICATION;
        case PhotoCaptureAttributeType.VIN_STICKER:
            return PhotoCaptureImageClass.VEHICLE_VIN_STICKER;
        case PhotoCaptureAttributeType.SINGLE_WIDE_SHOT:
            return PhotoCaptureImageClass.WIDE_SHOT;
        case PhotoCaptureAttributeType.THREE_CLOSE_UP:
            return PhotoCaptureImageClass.CLOSEUP_SHOT;
        case PhotoCaptureAttributeType.FOUR_CORNERS_CAPTURE:
            return PhotoCaptureImageClass.FOUR_CORNERS;
        case PhotoCaptureAttributeType.VIDEO_CAPTURE:
            return PhotoCaptureImageClass.WALK_AROUND_VIDEO;
        case PhotoCaptureAttributeType.INTELLIGENT_FOUR_CORNERS_VEHICLE_IMAGE:
            return PhotoCaptureImageClass.INTELLIGENT_FOUR_CORNERS_VEHICLE_IMAGE;
        case PhotoCaptureAttributeType.INTELLIGENT_LICENCE_PLATE:
            return PhotoCaptureImageClass.INTELLIGENT_LICENCE_PLATE;
        case PhotoCaptureAttributeType.INTELLIGENT_VIN_LOCATIONS:
            return PhotoCaptureImageClass.INTELLIGENT_VIN_LOCATIONS;
        case PhotoCaptureAttributeType.INTELLIGENT_VEHICLE_MILEAGE:
            return PhotoCaptureImageClass.INTELLIGENT_VEHICLE_MILEAGE;
        case PhotoCaptureAttributeType.INTELLIGENT_DAMAGE_WIDESHOT:
            return PhotoCaptureImageClass.INTELLIGENT_DAMAGE_WIDESHOT;
        case PhotoCaptureAttributeType.INTELLIGENT_DAMAGE_CLOSEUP:
            return PhotoCaptureImageClass.INTELLIGENT_DAMAGE_CLOSEUP;
        case PhotoCaptureAttributeType.INTELLIGENT_ILLUSTRATION:
            return PhotoCaptureImageClass.INTELLIGENT_ILLUSTRATION;
        case PhotoCaptureAttributeType.INTELLIGENT_WELLITAREA:
            return PhotoCaptureImageClass.INTELLIGENT_WELLITAREA;
        case PhotoCaptureAttributeType.INTELLIGENT_APPRAISER_VIEW:
            return PhotoCaptureImageClass.INTELLIGENT_APPRAISER_VIEW;
        default:
            return '';
    }
};
/**
 * Utility Function photoCapture.
 * @function getScreenName
 * @argument fileDescription
 * based on fileDescription will return screen name
 * @returns string
 */
export const getScreenName = (fileDescription) => {
    switch (fileDescription) {
        case PhotoCaptureImageDescription.LICENSE_PLATE:
            return PhotoCaptureAttributeType.LICENSE_PLATE_CAPTURE;
        case PhotoCaptureImageDescription.VEHICLE_MILEAGE:
            return PhotoCaptureAttributeType.MILEAGE_CAPTURE;
        case PhotoCaptureImageDescription.VEHICLE_IDENTIFICATION:
            return PhotoCaptureAttributeType.VIN_CAPTURE;
        case PhotoCaptureImageDescription.VEHICLE_VIN_STICKER:
            return PhotoCaptureAttributeType.VIN_STICKER;
        case PhotoCaptureImageDescription.WIDE_SHOT:
            return PhotoCaptureAttributeType.SINGLE_WIDE_SHOT;
        case PhotoCaptureImageDescription.TOP_CLOSEUP:
        case PhotoCaptureImageDescription.CENTER_CLOSEUP:
        case PhotoCaptureImageDescription.BOTTOM_CLOSEUP:
            return PhotoCaptureAttributeType.THREE_CLOSE_UP;
        case PhotoCaptureImageDescription.TOP_LEFT_CORNER:
        case PhotoCaptureImageDescription.TOP_RIGHT_CORNER:
        case PhotoCaptureImageDescription.BOTTOM_LEFT_CORNER:
        case PhotoCaptureImageDescription.BOTTOM_RIGHT_CORNER:
            return PhotoCaptureAttributeType.FOUR_CORNERS_CAPTURE;
        case PhotoCaptureImageDescription.WALK_AROUND_VIDEO:
            return PhotoCaptureAttributeType.VIDEO_CAPTURE;
        case PhotoCaptureImageDescription.SUMMARY:
            return PhotoCaptureAttributeType.SUMMARY;
        default:
            return '';
    }
};
/**
 * Utility Function photoCapture.
 * @function getAttachmentObject
 * @argument attachment attachment data
 * create a new object of attachment from attachment data
 * @return attachment object of type IPhotoCaptureAttachmentFileInfo
 */
const getAttachmentObject = (attachment) => {
    return Object.assign(Object.assign(Object.assign({ attachmentId: attachment.attchmentId, thumbNailAttachmentId: attachment.thumbnailAttachmentId, fileId: attachment.attachmentDocUId, thumbFileId: attachment.thumbnailDocUId, id: attachment.attachmentIdentifier, author: null, fileDescription: attachment.fileDescription, commentText: attachment.commentText || '', fullImgUrl: null, imageName: attachment.imageName, mimeType: getMimeType(MimeTypeService.lookup(attachment.imageName)), screenName: getScreenName(attachment.fileDescription), source: null, thumbUrl: null, parentQuestionId: attachment.parentQuestionId, questionnaireQuestionId: attachment.questionnaireQuestionId, documentId: attachment.documentId, isParentImage: attachment.isParentImage, parentIdentifier: attachment.parentIdentifier, damageName: attachment.damageName, additionalImageTag: attachment.additionalImageTag, damageId: attachment.damageId }, (typeof attachment.ocrText === 'string' ? { ocrText: attachment.ocrText } : {})), (attachment.historyInfo ? { historyInfo: attachment.historyInfo } : {})), { folderModelInfo: attachment.folderModelInfo, vehicleInfo: attachment.vehicleInfo });
};
/**
 * Utility Function photoCapture.
 * @function addNewAttachment
 * @argument attachments array of attachments
 * @argument attachmentInfo uploaded attachment response
 * create a new object of attachment from response and push into the attachment list
 * @return Array<Array<IPhotoCaptureAttachmentFileInfo>>
 */
export const addNewAttachment = (attachmentInfo, attachments = []) => {
    attachments.push([getAttachmentObject(attachmentInfo)]);
    return attachments;
};
/**
 * Utility Function photoCapture.
 * @function updateAttachments
 * @param photoCaptureState type IPhotoCaptureState
 * @param attachmentDataList list of attachments need to add/update in state
 *
 *  Checks attachmentList having same identifier with current state attachmentid
 *
 * When current state has same attachmentid with identifier of attachmentList then return
 * updated state with attachmentid and thumbNailAttachmentId
 * When current state  attachmentid not same with identifier of attachmentList then add
 * a new attachment in state.
 *
 * @return IPhotoCaptureState
 */
export const updateAttachments = (photoCaptureState, attachmentInfoList) => {
    const newState = cloneDeep(photoCaptureState);
    attachmentInfoList &&
        attachmentInfoList.map((attachmentData) => {
            var _a;
            let index = -1;
            if ((_a = photoCaptureState.attachmentInfo) === null || _a === void 0 ? void 0 : _a.length) {
                index = photoCaptureState.attachmentInfo.findIndex((attachment) => attachment[0].id === attachmentData.attachmentIdentifier);
            }
            if (index >= 0) {
                newState.attachmentInfo[index][0] = getAttachmentObject(attachmentData);
            }
            else {
                newState.attachmentInfo = addNewAttachment(attachmentData, newState.attachmentInfo || []);
            }
        });
    // Filter out the attachmentInfo from newState (based on attachmentIdentifier) that do not match the attachmentInfoList
    // for wide enhanced and closeup enhanced questionnaire type.
    newState.attachmentInfo = newState.attachmentInfo
        .map((attachmentList) => {
        if (!shouldExistForEnhancedQuestionnaire(attachmentList[0].fileDescription, attachmentInfoList[0].fileDescription)) {
            return attachmentList;
        }
        const existInAttachmentInfo = attachmentInfoList.some((attachment) => attachmentList[0].id === attachment.attachmentIdentifier);
        return existInAttachmentInfo ? attachmentList : [];
    })
        .filter(attachmentList => attachmentList.length);
    return Object.assign({}, newState);
};
/**
 * Determines wheteher the given attachment file description should exist for enhnaced questionnaire.
 * @param attachmentInfoFileDesc the fileDescription of the photoCaptureState.
 * @param attachmentInfoListFileDesc the first fileDescription of the attachmentInfoList.
 * @returns {boolean}
 */
const shouldExistForEnhancedQuestionnaire = (attachmentInfoFileDesc, attachmentInfoListFileDesc) => {
    let photoCaptureImageDescriptions = [];
    if (attachmentInfoListFileDesc === PhotoCaptureImageDescription.CLOSEUP_ENHANCED ||
        attachmentInfoListFileDesc === PhotoCaptureImageDescription.CLOSEUP_ENHANCED_ADDITIONAL) {
        photoCaptureImageDescriptions = [
            PhotoCaptureImageDescription.CLOSEUP_ENHANCED,
            PhotoCaptureImageDescription.CLOSEUP_ENHANCED_ADDITIONAL
        ];
    }
    else if (attachmentInfoListFileDesc === PhotoCaptureImageDescription.WIDE_ENHANCED ||
        attachmentInfoListFileDesc === PhotoCaptureImageDescription.WIDE_ENHANCED_ADDITIONAL) {
        photoCaptureImageDescriptions = [
            PhotoCaptureImageDescription.WIDE_ENHANCED,
            PhotoCaptureImageDescription.WIDE_ENHANCED_ADDITIONAL
        ];
    }
    return photoCaptureImageDescriptions.includes(attachmentInfoFileDesc);
};
export const photoCaptureAllowedMimeType = `${'.TXT,.' +
    PhotoCaptureAllowedMimeTypeConstant.join(',.')};capture=camera`;
export const photoCaptureFileExtensionAllowedForGallery = `${'.' +
    PhotoCaptureFileExtensionAllowedForGallery.join(',.')}`;
export const getImageByDescription = (fileDescription, imageData) => {
    return imageData && imageData.find((file) => file.fileDescription === fileDescription);
};
export const getPhotoCaptureImageDescription = (fileName) => {
    const mimeType = MimeTypeService.lookup(fileName);
    if (mimeType && mimeType.toLowerCase().indexOf('image/') >= 0 && mimeType.toLowerCase().indexOf('image/tiff') < 0)
        return PhotoCaptureImageDescription.PHOTO_DESCRIPTION;
    else
        return PhotoCaptureImageDescription.DOCUMENT_DESCRIPTION;
};
export const getAttachmentIdentifier = (photoCaptureAttachmentInfo, imageData, fileDescription, filesInfo) => {
    let currentImage;
    if (fileDescription)
        currentImage = getImageByDescription(fileDescription, imageData);
    if (currentImage)
        return currentImage.attachmentIdentifier;
    let attachmentIdentifier;
    do {
        attachmentIdentifier = new Date().getUTCMilliseconds();
    } while (
    // line will check if image exists in photoCaptureAttachmentInfo or imageData with generated attachmentIdentifier
    (photoCaptureAttachmentInfo &&
        photoCaptureAttachmentInfo.find((image) => image[0].id === attachmentIdentifier)) ||
        imageData.find((image) => image.attachmentIdentifier === attachmentIdentifier) ||
        (filesInfo &&
            filesInfo.length &&
            filesInfo.find((image) => image.attachmentIdentifier === attachmentIdentifier)));
    return attachmentIdentifier;
};
export const getProgressiveAttachmentIdentifier = (photoCaptureAttachmentInfo, imageData, isParentImage, damageName) => {
    let currentImage;
    if (isParentImage && damageName) {
        // group name
        currentImage =
            imageData &&
                imageData.find((file) => file.isParentImage === isParentImage && file.damageName === damageName);
    }
    else if (damageName) {
        //additionalImageTag
        currentImage =
            imageData &&
                imageData.find((file) => !file.isParentImage && file.additionalImageTag === damageName);
    }
    if (currentImage)
        return currentImage.attachmentIdentifier;
    let attachmentIdentifier;
    do {
        attachmentIdentifier = new Date().getUTCMilliseconds();
    } while (
    // line will check if image exists in photoCaptureAttachmentInfo or imageData with generated attachmentIdentifier
    (photoCaptureAttachmentInfo &&
        photoCaptureAttachmentInfo.find((image) => image[0].id === attachmentIdentifier)) ||
        imageData.find((image) => image.attachmentIdentifier == attachmentIdentifier));
    return attachmentIdentifier;
};
export const isInvalidFile = (files) => { var _a; return (_a = files.find(({ isUploadFailed }) => isUploadFailed)) === null || _a === void 0 ? void 0 : _a.isUploadFailed; };
/**
 * Utility Function photoCapture.
 * @function replaceMesssageTagToValue
 * @param message message
 * @param tags tags with there values
 *
 *  Update message with the value of options
 *
 * @return updated messsage
 */
export const replaceMesssageTagToValue = (message, tags) => {
    let updatedMessage = message;
    Object.keys(tags).map((tag) => (updatedMessage = updatedMessage.split(tag).join(tags[tag])));
    return updatedMessage;
};
/**
 * Utility Function photoCapture.
 * @function parseHtml
 * @param content string
 *
 * @return string
 */
export const parseHtml = (content) => {
    content = content.replace(/(?:\\[rn]|[\r\n]+)+/g, '');
    content = content.replace(/\\/g, '');
    return content;
};
/**
 * Utility Function photoCapture.
 * @function getPhotoCaptureCurrentAttachmentData
 * @param files IFile
 * @param fileDescription string
 * @param attachmentIdentifier number
 *
 * @return IPhotoCaptureAttachmentFile
 */
export const getPhotoCaptureCurrentAttachmentData = (files, fileDescription, attachmentIdentifier, parentQuestionId, questionnaireQuestionId, commentText) => {
    var _a, _b, _c;
    return ({
        fileName: files.fileName,
        docUID: files.docUID || '',
        thumbnailDocUId: ((_a = files.thumbnail) === null || _a === void 0 ? void 0 : _a.docUID) || '',
        fileDescription,
        attachmentIdentifier: attachmentIdentifier,
        parentQuestionId,
        questionnaireQuestionId,
        commentText,
        imageSize: files.fileSizeInBytes,
        thumbnailImageSize: (_b = files.thumbnail) === null || _b === void 0 ? void 0 : _b.fileSizeInBytes,
        imageDocId: files.docId,
        thumbnailDocId: (_c = files.thumbnail) === null || _c === void 0 ? void 0 : _c.docId
    });
};
/**
 * Utility Function photoCapture.
 * @function getPhotoCaptureProgressiveCurrentAttachmentData for mapping image data for current uploaded image
 * @param files IFile
 * @param fileDescription string
 * @param attachmentIdentifier number
 * @param parentQuestionId number
 * @param questionnaireQuestionId number
 * @param commentText string
 * @param parentIdentifier number
 * @param isParentImage boolean
 * @param damageName string
 * @param additionalImageTag string
 * @param damageId string
 *
 * @return IPhotoCaptureAttachmentFile
 */
export const getPhotoCaptureProgressiveCurrentAttachmentData = (files, fileDescription, attachmentIdentifier, parentQuestionId, questionnaireQuestionId, commentText, parentIdentifier, isParentImage, damageName, additionalImageTag, damageId, folderModelInfo) => {
    var _a, _b, _c;
    return ({
        fileName: files.fileName,
        docUID: files.docUID || '',
        thumbnailDocUId: ((_a = files.thumbnail) === null || _a === void 0 ? void 0 : _a.docUID) || '',
        fileDescription,
        attachmentIdentifier: attachmentIdentifier,
        parentQuestionId,
        questionnaireQuestionId,
        commentText,
        isParentImage,
        parentIdentifier,
        damageName,
        additionalImageTag,
        damageId,
        folderModelInfo,
        imageSize: files.fileSizeInBytes,
        thumbnailImageSize: (_b = files.thumbnail) === null || _b === void 0 ? void 0 : _b.fileSizeInBytes,
        imageDocId: files.docId,
        thumbnailDocId: (_c = files.thumbnail) === null || _c === void 0 ? void 0 : _c.docId
    });
};
/**
 * Utility Function photoCapture.
 * @function getSourceNameByAssignmentTypeAndSubType
 * @param assignmentType PhotoCaptureAssignmentTypes
 * @param assignmentSubType PhotoCaptureAssignmentSubTypes | null
 *
 * @return string
 */
export const getSourceNameByAssignmentTypeAndSubType = (assignmentType, assignmentSubType) => {
    switch (assignmentType) {
        case PhotoCaptureAssignmentTypes.PHOTO_CAPTURE:
            return PhotoCaptureConstants.PBE_PHOTO_CAPTURE;
        case PhotoCaptureAssignmentTypes.REQ_ADDITIONAL_PHOTO:
            return PhotoCaptureConstants.PBE_REQUEST_ADDITIONAL;
        case PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE:
            return assignmentSubType === PhotoCaptureAssignmentSubTypes.RP
                ? PhotoCaptureConstants.GPC_REQUEST_ADDITIONAL
                : PhotoCaptureConstants.GPC_PHOTO_CAPTURE;
        default:
            return '';
    }
};
export const isDeviceLibraryDisabled = (disableLibrary) => disableLibrary == PhotoCaptureConstants.Y && !new DeviceUtilitiesService().isMobile();
//array of artifactids to filter attachments of photoCapture state
let attachedArtifactIdsToFilterAttachment = [];
/**
 * Utility Function photoCapture.
 * @function isArtifactIdExist
 * @param attachedArtifactIds array of attachedartifact ids of attachment
 * @param artifactId artifactid of current page to check in attachedArtifactIds
 *
 * @return boolean
 */
export const isArtifactIdExist = (attachedArtifactIds, artifactId) => {
    const existArtifactId = attachedArtifactIds &&
        attachedArtifactIds.find((attachedArtifactId) => attachedArtifactId.parentQuestionId === artifactId.parentQuestionId &&
            attachedArtifactId.questionnaireQuestionId === artifactId.questionnaireQuestionId);
    return existArtifactId ? true : false;
};
/**
 * Utility Function photoCapture.
 * @function attachedArtifactIdsToUpdate
 * @param attachedArtifactIds array of attachedartifact ids of attachment
 * @param attachedArtifactId artifactid of current page to merge with attachedArtifactIds
 *
 * @return Array<IPhotoCaptureAttachedArtifactId>
 */
export const attachedArtifactIdsToUpdate = (attachedArtifactIds, attachedArtifactId) => {
    attachedArtifactIds = attachedArtifactIds && attachedArtifactIds.length ? attachedArtifactIds : [];
    const mergeAttachedArtifactIds = [
        ...attachedArtifactIds,
        ...[attachedArtifactId]
    ];
    return mergeAttachedArtifactIds;
};
/**
 * Utility Function photoCapture.
 * @function getPhotoCaptureSelectedAttachmentInfo
 * @param photoCaptureAttachmentInfo attachments available in photoCapture state
 * @param attachedArtifactIdsToFilterAttachment array of artifactids to filter attachments available in photoCapture state
 *
 * @return Array<Array<IPhotoCaptureAttachmentFileInfo>>
 */
const getPhotoCaptureSelectedAttachmentInfo = (photoCaptureAttachmentInfo, attachedArtifactIdsToFilterAttachment) => {
    let updatedPhotoCaptureAttachmentInfo = [
        ...photoCaptureAttachmentInfo
    ];
    attachedArtifactIdsToFilterAttachment &&
        attachedArtifactIdsToFilterAttachment.length &&
        attachedArtifactIdsToFilterAttachment.map((artifactId) => {
            updatedPhotoCaptureAttachmentInfo =
                updatedPhotoCaptureAttachmentInfo &&
                    updatedPhotoCaptureAttachmentInfo.filter((attachmentData) => attachmentData[0].questionnaireQuestionId !== artifactId.questionnaireQuestionId);
        });
    return updatedPhotoCaptureAttachmentInfo;
};
/**
 * Utility Function photoCapture.
 * @function removeNestedAttachmentsOnOptionChange
 * @param questionnaireQuestionId questionnaireQuestionId of current question
 * @param photoCaptureAttachmentInfo attachments available in photoCapture state
 * @param attachedArtifactIds  artifactids available in photoCapture State
 
 * @return Array<Array<IPhotoCaptureAttachmentFileInfo>>
 */
export const removeNestedAttachmentsOnOptionChange = (questionnaireQuestionId, photoCaptureAttachmentInfo, attachedArtifactIds = []) => {
    attachedArtifactIdsToFilterAttachment =
        attachedArtifactIds &&
            attachedArtifactIds.filter((attachedData) => attachedData.parentQuestionId === questionnaireQuestionId);
    let counter = 1;
    while (attachedArtifactIdsToFilterAttachment.length >= counter) {
        const nestedAttachedArtifactIds = attachedArtifactIds.filter((attachedData) => attachedData.parentQuestionId === attachedArtifactIdsToFilterAttachment[counter - 1].questionnaireQuestionId);
        attachedArtifactIdsToFilterAttachment = [
            ...attachedArtifactIdsToFilterAttachment,
            ...(nestedAttachedArtifactIds && nestedAttachedArtifactIds)
        ];
        counter++;
    }
    return getPhotoCaptureSelectedAttachmentInfo(photoCaptureAttachmentInfo, attachedArtifactIdsToFilterAttachment);
};
export const getHtmlUrlString = (content) => {
    if (content.indexOf('http://') === 0 || content.indexOf('https://') === 0) {
        return content;
    }
    else {
        return `http://${content}`;
    }
};
const translateFn = TranslationService.translate;
export const getErrorSummaryMessages = (fileSizeLimit, allowedMimeTypes = PhotoCaptureFileExtensionAllowedForGallery) => {
    const photoCaptureFileExtensionSupportFiles = `${'.' + allowedMimeTypes.join(',.')}`;
    const allowedExtensions = photoCaptureFileExtensionSupportFiles
        .split(',')
        .map(ext => `*${ext.trim()}`);
    const errorMessages = new Map();
    const maxFileSizeExceededTranslate = translateFn(`${RequestAdditionalErrorMessage.MAX_FILE_SIZE_EXCEEDED}`);
    const invalidFileTypeTranslate = translateFn(`${RequestAdditionalErrorMessage.INVALID_FILE_TYPE}`);
    errorMessages.set(FileUploadError.MAX_FILE_SIZE_EXCEEDED, `${maxFileSizeExceededTranslate} ${fileSizeLimit}MB.`);
    errorMessages.set(FileUploadError.INVALID_FILE_TYPE, `${invalidFileTypeTranslate}: ${allowedExtensions.join(', ').toLocaleLowerCase()}.`);
    return errorMessages;
};
export const getCommentData = (imageData) => imageData.reduce((accumulator, current) => {
    // Check if fileDescription and commentText are defined before adding to the accumulator
    if (current.fileDescription && current.commentText !== undefined) {
        accumulator[current.fileDescription] = current.commentText;
    }
    return accumulator;
}, {});
export const getPRGImageByDescription = (additionalImageTag, imageData) => imageData && imageData.find((file) => file.additionalImageTag === additionalImageTag);
export const getPRGPanelParentImages = (imageData) => imageData && imageData.filter((file) => file.isParentImage);
export const getOcrPreviewErrorMessage = (questionSubType, inputValue, countryCode) => {
    switch (questionSubType) {
        case PhotoCaptureAttributeType.VIN_CAPTURE:
            if (!OCR_previewScreen_RegEx_validator.VIN_CAPTURE_REGEX.test(inputValue)) {
                return IntelligentPhotoCapturePhotoPreviewConstants.VIN_CAPTURE_WARNING_MESSAGE;
            }
            return EMPTY_TEXT;
        case PhotoCaptureAttributeType.MILEAGE_CAPTURE:
            // Determine which regex to use based on country code
            const regex = countryCode === CountryCode.UNITED_STATES
                ? OCR_previewScreen_RegEx_validator.MILEAGE_CAPTURE_REGEX_US
                : OCR_previewScreen_RegEx_validator.MILEAGE_CAPTURE_REGEX_CA;
            // Return warning message if validation fails, otherwise empty
            return regex.test(inputValue)
                ? EMPTY_TEXT
                : IntelligentPhotoCapturePhotoPreviewConstants.MILEAGE_CAPTURE_WARNING_MESSAGE;
        default:
            return EMPTY_TEXT;
    }
};
export const getInputMaxLengthBasedOnQuestion = (questionSubType) => {
    switch (questionSubType) {
        case PhotoCaptureAttributeType.VIN_CAPTURE:
            return PhotoCaptureConstants.VIN_LENGTH;
        case PhotoCaptureAttributeType.MILEAGE_CAPTURE:
            return PhotoCaptureConstants.MILEAGE_LENGTH;
        case PhotoCaptureAttributeType.LICENSE_PLATE_CAPTURE:
            return PhotoCaptureConstants.LICENSE_LENGTH;
        default:
            return;
    }
};
export const shouldEnableOCR = (questionSubType) => OCR_ENABLED_SUBTYPES.includes(questionSubType);
export const getOCRRequestPayload = (imageDocUID, referenceId, attribute) => __awaiter(void 0, void 0, void 0, function* () {
    const s3Url = yield EnterpriseDocStoreService.getFileS3URL(imageDocUID);
    return {
        referenceId,
        images: [
            {
                uid: imageDocUID,
                uri: s3Url,
                attribute
            }
        ]
    };
});
/**
 * Checks if the given company code belongs to PRG group.
 * @function isPrgCompanyCode
 * @param companyCode as the company code to check.

 * @return {boolean}
 */
export const isPrgCompanyCode = (companyCode) => PROGRESSIVE_CO_CODES.includes(companyCode);
/**
 * Returns the files, based on imageContent.
 * @param imageContent The image data for the selected thumbnail.

 * @returns {Array<IFile>}
 */
export const getFilePayload = (imageContent) => [
    {
        id: EMPTY_TEXT,
        fileName: imageContent.fileName,
        docId: 0,
        docUID: imageContent.docUID,
        thumbnail: {
            docUID: imageContent.thumbnailDocUId
        },
        description: imageContent.fileDescription
    }
];
export const attachOCRExtractedDataToComment = (questionSubType, ocrText, countryCode) => {
    const trimmedOCR = ocrText ? ocrText.toString().trim() : EMPTY_TEXT;
    const questionSubTypeLabels = {
        [PhotoCaptureAttributeType.VIN_CAPTURE]: 'VIN',
        [PhotoCaptureAttributeType.LICENSE_PLATE_CAPTURE]: 'License Plate',
        [PhotoCaptureAttributeType.MILEAGE_CAPTURE]: countryCode === CountryCode.UNITED_STATES ? 'Odometer' : 'Mileage'
    };
    const label = questionSubTypeLabels[questionSubType] || '';
    return `${translateFn(label)}: ${trimmedOCR}`;
};
export const getOCRAppendedComment = (enteredComment, commentPrefix) => {
    let finalComment = enteredComment.replace(/\n/g, '\\n'); // Added \n in place of line break
    if (!finalComment.startsWith(commentPrefix)) {
        finalComment = `${commentPrefix}\n${enteredComment}`;
    }
    else {
        const firstCharAfterOCR = finalComment.charAt(commentPrefix.length).trim();
        const secondCharAfterOCR = finalComment.charAt(commentPrefix.length + 1);
        const twoCharsAfterOCR = firstCharAfterOCR + secondCharAfterOCR;
        if (firstCharAfterOCR && (!secondCharAfterOCR || twoCharsAfterOCR !== '\\n')) {
            finalComment = `${commentPrefix}\n${enteredComment}`;
        }
        else {
            finalComment = enteredComment;
        }
    }
    return finalComment;
};
const createDocHistory = (historyInfoIndex, docUID) => {
    const docIdHistory = {
        indexId: historyInfoIndex,
        docStoreId: docUID,
        imageDateTime: formatDateTime(new Date())
    };
    return docIdHistory;
};
export const getUpdatedFileDescriptionHistory = (isFileDescriptionExists, fileDescription, currentfileDescriptionHistory, allFileDescriptionHistories, additionalImageTag) => {
    let updatedAttachmentHistories = [];
    if (!isFileDescriptionExists) {
        updatedAttachmentHistories = [...allFileDescriptionHistories, currentfileDescriptionHistory];
    }
    else {
        updatedAttachmentHistories = allFileDescriptionHistories.map(existingFileDescriptionHistory => existingFileDescriptionHistory.fileDescription === fileDescription &&
            (!existingFileDescriptionHistory.additionalImageTag ||
                existingFileDescriptionHistory.additionalImageTag === additionalImageTag)
            ? currentfileDescriptionHistory
            : existingFileDescriptionHistory);
    }
    return updatedAttachmentHistories;
};
export const createAndUpdateAttachmentHistory = (allFileDescriptionHistories, fileDescription, docUID, imageHistoryMetaDetails, isNewImageTaken, additionalImageTag) => {
    let currentfileDescriptionHistory = allFileDescriptionHistories.find((fileDescriptionImageHistory) => fileDescriptionImageHistory.fileDescription === fileDescription &&
        (!fileDescriptionImageHistory.additionalImageTag ||
            fileDescriptionImageHistory.additionalImageTag === additionalImageTag));
    const isFileDescriptionExists = !!currentfileDescriptionHistory;
    let docIdHistory;
    if (!currentfileDescriptionHistory || !currentfileDescriptionHistory.historyInfo) {
        currentfileDescriptionHistory = {
            fileDescription,
            historyInfo: [],
            additionalImageTag
        };
    }
    else if (!isNewImageTaken) {
        docIdHistory = currentfileDescriptionHistory.historyInfo
            .filter(docHistory => docHistory.docStoreId === docUID)
            .pop();
    }
    if (!docIdHistory && currentfileDescriptionHistory.historyInfo) {
        const indexID = currentfileDescriptionHistory.historyInfo.length;
        docIdHistory = createDocHistory(indexID, docUID);
        currentfileDescriptionHistory.historyInfo.push(docIdHistory);
    }
    if (imageHistoryMetaDetails && docIdHistory) {
        docIdHistory = Object.assign(Object.assign({}, docIdHistory), imageHistoryMetaDetails);
    }
    if (currentfileDescriptionHistory.historyInfo && docIdHistory) {
        currentfileDescriptionHistory.historyInfo[docIdHistory.indexId] = docIdHistory;
    }
    const updatedFileDescriptionHistory = getUpdatedFileDescriptionHistory(isFileDescriptionExists, fileDescription, currentfileDescriptionHistory, allFileDescriptionHistories, additionalImageTag);
    return updatedFileDescriptionHistory;
};
export const getIQAHistoryDetails = (iqaScores) => {
    const { blurScore: iqaBlurScore = 0, brightnessScore: iqaBrightnessScore = 0, contrastScore: iqaContrastScore = 0, gammaScore: iqaGammaScore = 0, noiseScore: iqaNoiseScore = 0 } = iqaScores !== null && iqaScores !== void 0 ? iqaScores : {};
    const historyIQADetails = {
        iqaBlurScore,
        iqaBrightnessScore,
        iqaContrastScore,
        iqaGammaScore,
        iqaNoiseScore
    };
    return historyIQADetails;
};
//errorMesssage handling based on statusCode near future
export const getErrorMessagesBasedOnStatusCode = (error) => {
    if (!error) {
        return SERVICE_FAIL_STATUS;
    }
    const statusCode = error.StatusCode ? parseInt(error.StatusCode) : HttpStatusCode.InternalServerError;
    switch (statusCode) {
        case HttpStatusCode.BadRequest:
        case HttpStatusCode.NotFound:
        case HttpStatusCode.Unauthorized:
        case HttpStatusCode.Forbidden:
        case HttpStatusCode.InternalServerError:
        case HttpStatusCode.NoContent:
        default:
            return SERVICE_FAIL_STATUS;
    }
};
/**
 * Creates standard HTTP headers with optional custom headers
 * @param customHeaders Optional additional headers to include
 * @returns Record of header key-value pairs
 */
export function createStandardHeaders(customHeaders) {
    return Object.assign({ [HttpHeaderType.CONTENT_TYPE]: HttpContentType.APPLICATION_JSON, [HttpHeaderType.ACCEPT]: HttpContentType.APPLICATION_JSON, [HttpHeaderType.PRAGMA]: HttpCacheType.NO_CACHE }, customHeaders);
}
/**
 * Creates an HTTP request object with standard configuration
 * @param uri The endpoint URI
 * @param method The HTTP method (GET, POST, etc.)
 * @param headers Headers to include in the request
 * @param body Optional request body for POST/PUT requests
 * @returns Request object ready for fetch
 */
export function createHttpRequest(uri, method = HttpMethodType.GET, headers, body) {
    const requestInit = {
        method,
        cache: HttpCacheType.NO_CACHE,
        headers: headers || createStandardHeaders()
    };
    if (body) {
        requestInit.body = JSON.stringify(body);
    }
    return new Request(uri, requestInit);
}
/**
 * Get folder model information for a given damage ID
 * @param damageId - The ID of the damage to find folder information for
 * @param folderOptionList - List of folder options
 * @returns The folder model information or undefined if not found
 */
export const getFolderModelInfo = (damageId, folderOptionList) => {
    if (!folderOptionList || folderOptionList.length === 0) {
        return undefined;
    }
    const folder = folderOptionList.find((folder) => folder.folderTypeId === damageId);
    return (folder && {
        folderTypeId: folder.folderTypeId,
        folderTypeCode: folder.folderTypeCode,
        folderTypeDesc: folder.folderTypeDesc,
        active: folder.isActive,
        folderAlias: folder.folderAlias
    });
};
/**
 * Determines whether Progressive Capture screens should be rendered based on the question subtype
 * @param {PhotoCaptureAttributeType} questionSubType - The subtype of the photo capture question
 * @returns {boolean} - True if the question subtype is configured for Progressive Capture workflow
 */
export const shouldRenderProgressiveScreens = (questionSubType) => PRG_QUESTIONS_SUB_TYPE.includes(questionSubType);
export const downloadFiles = (files) => {
    const download = (files) => {
        const file = files.pop();
        if (file) {
            const anchor = document.createElement('a');
            anchor.setAttribute('href', URL.createObjectURL(file));
            anchor.setAttribute('download', file.name);
            anchor.setAttribute('target', '_parent');
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
        }
        if (files.length === 0) {
            clearInterval(interval);
        }
    };
    const interval = setInterval(download, 300, files);
};
/**
 * Processes vehicle information data and selected entries to create a standardized vehicle selection object.
 *
 * This function handles two scenarios:
 * 1. If the selectedInfoEntries map is empty (or vehicleInfoData.Vehicle exists),
 *    it returns the Vehicle property from vehicleInfoData as is.
 * 2. If selectedInfoEntries is not empty, it processes the vehicleInfoData to create
 *    a new VehicleInfoEntry<IVehicleSelection> object, potentially using values from selectedInfoEntries
 *    for fields with multiple options.
 *
 * The function generates random IDs and a ServiceBarcode when creating a new object.
 * It processes various vehicle attributes like Type, Year, Make, Model, etc.,
 * using either the first entry in vehicleInfoData or the corresponding entry in selectedInfoEntries
 * if multiple options exist for a field.
 *
 * @param {VehicleInfoData} vehicleInfoData - The raw vehicle information data object.
 * @param {Map<string, VehicleInfoEntry<string | number>>} selectedInfoEntries - A map of selected entries for vehicle attributes.
 * @returns {VehicleInfoEntry<IVehicleSelection>} A processed vehicle selection object conforming to the IVehicleSelection interface.
 *
 * @example
 * const vehicleInfoData = { Vin: "1HGCM82633A004352", Types: [{Id: 1, Value: "Car"}], ... };
 * const selectedInfoEntries = new Map([["SubModels", {Id: 2, Value: "LX"}], ...]);
 * const result = processVinData(vehicleInfoData, selectedInfoEntries);
 */
export const processVinData = (vehicleInfoData = new VehicleInfoState().vehicleInfoData, selectedInfoEntries = new Map()) => {
    // Check if selectedInfoEntries is empty
    if (vehicleInfoData && vehicleInfoData.Vehicle) {
        // If selectedInfoEntries is empty, return the Vehicle property from vehicleInfoData
        return vehicleInfoData.Vehicle;
    }
    // If selectedInfoEntries is not empty, process the data
    const result = {
        Id: 0,
        IsFleet: false,
        Next: '',
        Value: {
            Id: 0,
            ServiceBarcode: '',
            Vin: vehicleInfoData.Vin
        }
    };
    const processField = (fieldName, dataArray) => {
        if (!isEmpty(dataArray)) {
            if (dataArray.length > 1) {
                if (selectedInfoEntries.has(fieldName)) {
                    return pick(selectedInfoEntries.get(fieldName), ['Id', 'Value']);
                }
                else {
                    return null;
                }
            }
            else {
                return pick(first(dataArray), ['Id', 'Value']);
            }
        }
        return null;
    };
    const fieldsToProcess = [
        ['Id', 'Id'],
        ['ServiceBarcode', 'ServiceBarcode'],
        ['Type', 'Types'],
        ['Year', 'Years'],
        ['Make', 'Makes'],
        ['Model', 'Models'],
        ['SubModel', 'SubModels'],
        ['BodyStyle', 'BodyStyles'],
        ['Engine', 'Engines'],
        ['Transmission', 'Transmissions'],
        ['DriveTrain', 'DriveTrains'],
        ['FuelType', 'FuelType']
    ];
    forEach(fieldsToProcess, ([resultField, dataField]) => {
        result.Value[resultField] = processField(dataField, vehicleInfoData[dataField]);
    });
    return result;
};
export var ImageAlbumOrganizer;
(function (ImageAlbumOrganizer) {
    ImageAlbumOrganizer.organizeImagesIntoAlbums = (attachmentInfo, countryCode, language) => {
        const categoryToFileTypesMap = getCategoryToFileTypesMapping();
        const tileIdCounter = { value: 1 };
        const downloadableTileIds = [];
        const processedImageIds = new Set();
        let albumsCollection = [];
        processAttachments(attachmentInfo.flat(), categoryToFileTypesMap, albumsCollection, downloadableTileIds, processedImageIds, tileIdCounter, countryCode, language);
        removeEmptyAlbums(albumsCollection);
        return { albums: albumsCollection, tileDocIds: downloadableTileIds };
    };
    const getCategoryToFileTypesMapping = () => ({
        [PhotoCaptureDownloadArtifactsCategoryNames.VEHICLE_INFORMATION]: [
            PhotoCaptureImageDescription.VEHICLE_IDENTIFICATION,
            PhotoCaptureImageDescription.VEHICLE_MILEAGE,
            PhotoCaptureImageDescription.LICENSE_PLATE
        ],
        [PhotoCaptureDownloadArtifactsCategoryNames.THREE_CORNERS]: [
            PhotoCaptureImageDescription.TOP_CLOSEUP,
            PhotoCaptureImageDescription.CENTER_CLOSEUP,
            PhotoCaptureImageDescription.BOTTOM_CLOSEUP
        ],
        [PhotoCaptureDownloadArtifactsCategoryNames.FOUR_CORNERS]: [
            PhotoCaptureImageDescription.TOP_LEFT_CORNER,
            PhotoCaptureImageDescription.TOP_RIGHT_CORNER,
            PhotoCaptureImageDescription.BOTTOM_LEFT_CORNER,
            PhotoCaptureImageDescription.BOTTOM_RIGHT_CORNER
        ],
        [PhotoCaptureDownloadArtifactsCategoryNames.WIDE_SHOT]: [PhotoCaptureImageDescription.WIDE_SHOT],
        [PhotoCaptureDownloadArtifactsCategoryNames.VEHICLE_DAMAGE]: [
            PhotoCaptureImageDescription.WIDE_ENHANCED,
            PhotoCaptureImageDescription.WIDE_ENHANCED_ADDITIONAL,
            PhotoCaptureImageDescription.CLOSEUP_ENHANCED,
            PhotoCaptureImageDescription.CLOSEUP_ENHANCED_ADDITIONAL
        ],
        [PhotoCaptureDownloadArtifactsCategoryNames.REQUEST_ADDITIONAL]: [PhotoCaptureImageDescription.PHOTO_DESCRIPTION]
    });
    const processAttachments = (allAttachments, categoryToFileTypesMap, albumsCollection, downloadableTileIds, processedImageIds, tileIdCounter, countryCode, language) => {
        allAttachments.forEach((attachment) => {
            const { fileDescription, imageName, id, isParentImage } = attachment;
            if (shouldSkipAttachment(imageName, id, processedImageIds)) {
                return;
            }
            const categoryLabel = Object.keys(categoryToFileTypesMap).find((key) => categoryToFileTypesMap[key].includes(fileDescription));
            if (!categoryLabel) {
                return;
            }
            const album = findOrCreateAlbum(albumsCollection, translateFn(categoryLabel));
            if (isParentImage) {
                createParentImageAlbum(attachment, album, allAttachments, downloadableTileIds, processedImageIds, tileIdCounter, language);
            }
            else {
                createStandaloneImageAlbum(attachment, album, downloadableTileIds, processedImageIds, tileIdCounter, countryCode);
            }
        });
    };
    const shouldSkipAttachment = (imageName, id, processedImageIds) => {
        const fileUploadError = FileValidationService.validateFile({
            file: { name: imageName },
            allowedFileTypes: PhotoCaptureAllowedMimeTypeConstant
        });
        return !!fileUploadError || processedImageIds.has(id);
    };
    const findOrCreateAlbum = (albumsCollection, albumName) => {
        const existingAlbum = albumsCollection.find((album) => album.header === albumName);
        if (existingAlbum) {
            return existingAlbum;
        }
        const newAlbum = {
            id: albumsCollection.length.toString(),
            tiles: [],
            header: albumName,
            subAlbums: []
        };
        albumsCollection.push(newAlbum);
        return newAlbum;
    };
    const createParentImageAlbum = (attachment, mainAlbum, allAttachments, downloadableTileIds, processedImageIds, tileIdCounter, language) => {
        processedImageIds.add(attachment.id);
        const parentTile = createTile(attachment, tileIdCounter, EMPTY_TEXT, true);
        downloadableTileIds.push({
            tileId: parentTile.id,
            docUID: attachment.fileId,
            questionnaireQuestionId: attachment.questionnaireQuestionId
        });
        const subalbum = createSubalbum(attachment, parentTile, language);
        if (mainAlbum.subAlbums) {
            mainAlbum.subAlbums.push(subalbum);
        }
        addChildImagesToSubalbum(attachment.id, subalbum, allAttachments, processedImageIds, downloadableTileIds, tileIdCounter);
    };
    const createStandaloneImageAlbum = (attachment, album, downloadableTileIds, processedImageIds, tileIdCounter, countryCode) => {
        processedImageIds.add(attachment.id);
        const tile = createTile(attachment, tileIdCounter, countryCode, false);
        album.tiles.push(tile);
        downloadableTileIds.push({
            tileId: tile.id,
            docUID: attachment.fileId,
            questionnaireQuestionId: attachment.questionnaireQuestionId
        });
    };
    const createTile = (attachment, tileIdCounter, countryCode, isPrimaryImage) => {
        const tileId = tileIdCounter.value++;
        const tags = createTagsforAlbums(attachment, countryCode);
        return {
            id: tileId,
            url: attachment.thumbFileId ? EnterpriseDocStoreService.createFileUrl(attachment.thumbFileId) : EMPTY_TEXT,
            fileName: attachment.imageName,
            isShared: false,
            isShareable: false,
            isReceived: false,
            isSent: false,
            isSelected: false,
            isSelectModeOn: true,
            isPrimaryImage,
            index: tileId,
            height: downloadAartifactsGalleryProps.smallTileHeight,
            width: downloadAartifactsGalleryProps.smallTileWidth,
            tags: tags && tags.length ? tags : []
        };
    };
    const createSubalbum = (parentAttachment, parentTile, language) => ({
        id: `sub_${parentTile.id}`,
        tiles: [parentTile],
        header: parentAttachment.folderModelInfo
            ? getDamageGroupFolderDescription(parentAttachment.folderModelInfo.folderAlias, language)
            : EMPTY_TEXT,
        subAlbums: []
    });
    const addChildImagesToSubalbum = (parentId, subalbum, allAttachments, processedImageIds, downloadableTileIds, tileIdCounter) => {
        allAttachments
            .filter((child) => !child.isParentImage && child.parentIdentifier === parentId)
            .forEach((child) => {
            processedImageIds.add(child.id);
            const childTile = createTile(child, tileIdCounter, EMPTY_TEXT, false);
            subalbum.tiles.push(childTile);
            downloadableTileIds.push({
                tileId: childTile.id,
                docUID: child.fileId,
                questionnaireQuestionId: child.questionnaireQuestionId
            });
        });
    };
    const removeEmptyAlbums = (albumsCollection) => {
        const nonEmptyAlbums = albumsCollection.filter((album) => album.tiles.length > 0 || (album.subAlbums && album.subAlbums.length > 0));
        albumsCollection.length = 0;
        albumsCollection.push(...nonEmptyAlbums);
        albumsCollection.forEach((album) => {
            if (album.subAlbums) {
                album.subAlbums = album.subAlbums.filter((subalbum) => subalbum.tiles.length > 0);
            }
        });
    };
    const createTagsforAlbums = (attachment, countryCode) => {
        const fileTypeLabels = {
            [PhotoCaptureImageDescription.VEHICLE_IDENTIFICATION]: PhotoCaptureDownloadArtifactsLabelNames.VIN,
            [PhotoCaptureImageDescription.LICENSE_PLATE]: PhotoCaptureDownloadArtifactsLabelNames.PLATE,
            [PhotoCaptureImageDescription.VEHICLE_MILEAGE]: countryCode === CountryCode.UNITED_STATES
                ? PhotoCaptureDownloadArtifactsLabelNames.ODOMETER
                : PhotoCaptureDownloadArtifactsLabelNames.MILEAGE
        };
        const labelKey = fileTypeLabels[attachment.fileDescription];
        const result = [];
        labelKey && result.push({ text: translateFn(labelKey), type: TagType.TEXT });
        attachment.ocrText && result.push({ text: attachment.ocrText, type: TagType.FILE_NAME });
        return result;
    };
})(ImageAlbumOrganizer || (ImageAlbumOrganizer = {}));
export const getDamageGroupFolderDescription = (folderAlias, language) => {
    const aliasMap = new Map(folderAlias.map(alias => [alias.language, alias.folderDesc]));
    return aliasMap.get(language) || aliasMap.get(PhotoCaptureConstants.EN_US) || EMPTY_TEXT;
};
/**
 * Determines the appropriate view based on screen name, IQA parameters, and error state
 *
 * @param screenName - The current screen name
 * @param isIQAParameterAllowed - Whether additional IQA options are enabled
 * @param shouldShowIQAErrorScreen - Whether an IQA error occurred
 * @param currentView - The current view state
 * @returns The appropriate view to display
 */
export const determineStateView = (screenName, isIQAParameterAllowed, shouldShowIQAErrorScreen, currentView) => {
    if (screenName === PhotoCaptureImageDescription.SUMMARY) {
        return IntelligentPhotoCaptureViewType.NONE;
    }
    // If IQA parameters are not allowed, determine view based on error state
    if (!isIQAParameterAllowed) {
        return shouldShowIQAErrorScreen
            ? IntelligentPhotoCaptureViewType.RETAKE_PAGE
            : IntelligentPhotoCaptureViewType.COMMENT;
    }
    return currentView;
};
//# sourceMappingURL=photoCaptureCommonUtilities.js.map